<template>
  <div>
    <dialog-component
        :dialog-title="titleAlarmInformation"
        :closeClick = "showClose"
        :dialogVisible.sync="alarmInformationVisible"
        @dialogClose="dialog"
        center
        width="75vw">
      <div slot="content" style="height: 65vh">
<!--        告警信息-->
        <el-row style="background-color: rgba(41, 155, 255, 0.1);">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" >
            <div style="height: 30px; background-color: rgb(8 47 83); text-align: center; line-height: 28px;">告警信息</div>
            <div style="margin-left: 20%; margin-right: 20%">
              <div style="font-weight:bold; margin-top: 40px;">{{latestAlarmInformation.deviceName}}&nbsp;&nbsp;{{latestAlarmInformation.pointName}}</div>
              <div style="margin-top: 10px; color: rgb(211 215 220);">{{latestAlarmInformation.msg}}</div>
              <div style="margin-top: 10px; margin-bottom: 80px;">
                <span  :style="{color: latestAlarmInformation.levelColor}">{{latestAlarmInformation.levelName}}</span>
                <div style="float: right;">{{latestAlarmInformation.createTime}}</div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 7px;">
          <!--        设备信息-->
            <el-col :xl="6" :lg="6" :md="6" :sm="24" :xs="24" style="background-color: rgba(41, 155, 255, 0.1);">
              <div style="height: 30px; background-color: rgb(8 47 83); text-align: center; line-height: 28px;">设备信息</div>
              <div style="margin-left: 20%; margin-right: 15%">
                <div style="margin-top: 60px;">
                  <span style="color: rgb(211 215 220);">名称：</span>
                  <span>{{device_information.name}}</span>
                </div>
                <div style="margin-top: 10px;">
                  <span style="color: rgb(211 215 220);">类型：</span>
                  <span>{{device_information.typeCnName}}</span>
                </div>
                <div style="margin-top: 10px;">
                  <span style="color: rgb(211 215 220);">型号：</span>
                  <span>{{device_information.modelCnName}}</span>
                </div>
                <div style="margin-top: 10px; margin-bottom: 188px;">
                  <span style="color: rgb(211 215 220);">品牌：</span>
                  <span>{{device_information.brandCnName}}</span>
                </div>
              </div>
            </el-col>

          <!--        联动视频-->
          <el-col :xl="18" :lg="18" :md="18" :sm="24" :xs="24" style="padding-left: 5px;">
            <div style="background-color: rgba(41, 155, 255, 0.1); height: 393px;">
              <div style="height: 30px; background-color: rgb(8 47 83); text-align: center; line-height: 28px;">联动视频</div>
              <el-row style=" margin-top: 20px;" v-if="linkageVideo.length > 0" >
                <el-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24" v-for="(item, i) in this.linkageVideo" :key="item.id" :style="videoStyle(i)" >
                  <div style="height: 393px;width: 100%;" @mouseleave="mouseLeave">
                    <div style="margin-bottom: 5px;">{{item.name}}</div>
                    <div  style="width: 100%; height: 190px;" @mouseover="mouseOver(item.id)" >
                      <div v-if="videoType == 'realTimeAlarm' && !startVideoLinkageVisible">
                        <video-playback v-show="checkSwitch(item.id)" :videoCameraId="queryVideoByVideoId(item.id)"></video-playback>
                      </div>
                      <div v-else>
                        <video-playback v-show="checkSwitch(item.id)" :videoCameraId="queryVideoByVideoId(item.id)"></video-playback>
                        <video-component :properties="JSON.parse(item.portProperties)"
                                         :device-info="item"
                                         v-show="!checkSwitch(item.id) && videoType != 'history' "></video-component>
                      </div>
                    </div>

                    <div v-if="mouseMonitoring && (initialization || videoId == item.id)" style="background-color: #0B355D; max-height: 168px; width: 100%; overflow:auto;">
                      <el-row v-if="alarmLinkageVideoList.length > 0">
                        <div  v-for="videodates in alarmLinkageVideoList" :key="videodates.id">
                          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" v-if="videodates.deviceId = videoId"
                                  style="padding-bottom: 5px; padding-top: 5px; margin-right: 5%; margin-left: 5%;">
                            <el-button style="border:1px dashed #175E9E; width: 90%; text-align: center; border-radius:5px;" @touchstart="historicalVideo(videodates.cameraId,item.id)"  @click="historicalVideo(videodates.cameraId,item.id)">
                              <span style="font-size: 0.8em;">{{videodates.startTime}}&nbsp;至&nbsp;{{videodates.stopTime}}</span>
                            </el-button>
                          </el-col>
                        </div>
                        <div v-if="videoType != 'history' " style="float: right; color: #4a8bf8; margin-top: 5px; margin-bottom: 5px;  margin-right: 10%;">
                          <div v-if="videoType == 'realTimeAlarm' && !startVideoLinkageVisible"></div>
                          <div v-else>
                            <span v-if="checkSwitch(item.id)" @touchstart="historicalPicture('realTime',item.id)"  @click="historicalPicture('realTime',item.id)">查看实时画面</span>
                            <span v-else  @touchstart="historicalPicture('history',item.id)"  @click="historicalPicture('history',item.id)">查看历史画面</span>
                          </div>
                        </div>
                      </el-row>
                    </div>
                    <el-row style="margin-top: 5px;" v-if="(!mouseMonitoring || videoId != item.id) && alarmLinkageVideoList.length > 0">
                      <div  v-for="(videodate,index) in alarmLinkageVideoList" :key="videodate.id">
                        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" v-if="index < 2"
                                style="margin-bottom: 5px; margin-left: 5%; margin-right: 5%" >
                          <el-button style="border:1px dashed #175E9E; width: 90%; text-align: center; border-radius:5px;" @touchstart="historicalVideo(videodate.cameraId,item.id)" @click="historicalVideo(videodate.cameraId,item.id)">
                            <span style="font-size: 0.8em;">{{videodate.startTime}}&nbsp;至&nbsp;{{videodate.stopTime}}</span>
                          </el-button>
                        </el-col>
                      </div>
                      <div v-if="videoType != 'history'" style="margin-bottom: 5px; float: right; color: #4a8bf8; padding-right: 10%;" >
                        <div v-if="videoType == 'realTimeAlarm' && !startVideoLinkageVisible"> </div>
                        <div v-else>
                          <span v-if="checkSwitch(item.id)" @touchstart="historicalPicture('realTime',item.id)"  @click="historicalPicture('realTime',item.id)">查看实时画面</span>
                          <span v-else @touchstart="historicalPicture('history',item.id)"  @click="historicalPicture('history',item.id)">查看历史画面</span>
                        </div>
                      </div>
                    </el-row>

                    <div v-else-if="(!mouseMonitoring || videoId != item.id) && videoType != 'history'" style="margin-bottom: 144px; float: right; color: #4a8bf8; margin-top: 10px;">
                      <div v-if="videoType == 'realTimeAlarm' && !startVideoLinkageVisible"></div>
                      <div v-else>
                        <a style="cursor:pointer;" v-if="checkSwitch(item.id)" @touchstart="historicalPicture('realTime',item.id)"  @click="historicalPicture('realTime',item.id)">查看实时画面</a>
                        <a style="cursor:pointer;" v-else @touchstart="historicalPicture('history',item.id)"  @click="historicalPicture('history',item.id)">查看历史画面</a>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <no-data style="margin-top: 12%" v-else></no-data>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 100px; margin-bottom: 15px;">
        <el-button v-if="!latest_alarm_information.isConfirm && videoType != 'history'" @touchstart="alarmHandling"  @click="alarmHandling" size="mini" type="primary">处 理</el-button>
        <el-button v-if="videoType != 'history'" @@touchstart="alarmElimination"  @click="alarmElimination" size="mini" type="primary">消 警</el-button>
        <el-button  @touchstart="viewLog"  @click="viewLog" size="mini" >查看日志</el-button>
      </div>
    </dialog-component>

    <alarm-handling :visible="deviceDialogVisible"
                    :title="title"
                    :alarmId="alarmId"
                    :code="code"
                    :idList="idList"
                    opinion=""
                    :activities="activities"
                    @refreshAlarmInformation="refreshAlarmInformation"
                    @dialogClose="(data) => this.deviceDialogVisible = data"></alarm-handling>

  </div>
</template>
<script>
import {getDeviceInfoById} from "@/network/device-info";
import VideoComponent from "@/components/video/VideoComponent";
import {listByRecordId, packageList} from "@/network/alarm-log";
import AlarmHandling from "@/views/alarm/AlarmHandling";
import DialogComponent from "@/components/DialogComponent";
import NoData from "@/components/NoData";
import {
  disConnectByRecordIdAndDeviceId,
  getAlarmLinkageHistorVideoList,
  getAlarmLinkageVideoList
} from "@/network/alarm_linkage_video";
import VideoPlayback from "@/components/video/VideoPlayback";
import {getAlarmRealTimeById} from "@/network/alarm-realtime";

export default {
  name: "AlarmInformation",
  components:{DialogComponent ,VideoComponent,VideoPlayback,AlarmHandling,NoData},
  props: ["visible","latestAlarmInformation","videoType","startVideoLinkage"],
  data(){
    return{
      titleAlarmInformation: '实时告警',
      alarmInformationVisible: false, //实时告警弹窗
      startVideoLinkageVisible:false, //是否开启视频联动
      latest_alarm_information: {}, //最新告警记录
      showClose: false,
      initialization: true, //初始化视频显示
      device_information: {
        name: "",
        typeCnName: "",
        modelCnName: "",
        brandCnName: "",
      }, //告警设备信息
      linkageVideo: [],//告警联动视频

      spaceId: '', //空间标识
      typeList: ["PM_Video", "Video_vlc", "PM_CAM",'PM_DVR'], //视频设备类型

      deviceDialogVisible: false, //处理、消警、告警日志弹窗
      activities: [], //告警日志内容
      code: 0,
      title: '', //弹窗标题
      diaWidth: '', //弹窗宽度
      diaHeight: '', //弹窗高度
      alarmId: '', //告警ID
      idList: [],
      mouseMonitoring: false,
      ejectMouseMonitoring: false,
      videoId: '',
      alarmLinkageVideoList: [],
      checkSwitchList: [], //查看切换(true:显示查看历史画面；false：显示查看实时画面)
      videoSwitch: true, //视频切换（true:查看实时视频；false：查看历史视频）
      cameraId: '', //历史视频地址
      selectedHistoricalVideoAddressList: [],//选中的历史视频地址集合

      type:'',
    }
  },
  created() {
  },
  mounted() {
  },
  watch:{
    visible(newval){
      this.alarmInformationVisible = newval;
      this.latest_alarm_information = this.latestAlarmInformation;
      console.log("父页传过来的参数：",this.latest_alarm_information,this.alarmInformationVisible);

      //告警联动视频
      this.getAlarmLinkageVideo();
      this.type = this.videoType;
      if(this.videoType === 'history'){
        this.titleAlarmInformation = "历史告警";
      }
      console.log("是否开启视频：",this.startVideoLinkage);
      this.startVideoLinkageVisible = this.startVideoLinkage;
    },

  },
  methods:{
    //获取告警联动视频列表
    getAlarmLinkageVideo(){
      let deviceIds = [];
      let alarmRecordId;
      if (this.videoType === "history"){
        deviceIds = [];
        alarmRecordId =  this.latest_alarm_information.id;
        getAlarmLinkageHistorVideoList(alarmRecordId).then(res =>{
          if (res.code === 0) {
            if (res.data.length > 0) {
              this.alarmLinkageVideoList = res.data;
              console.log("历史告警联动视频：",this.alarmLinkageVideoList);

              for (var j = 0; j < res.data.length; j++) {
                let historyVideoState = this.historyVideo(res.data[j].cameraId,res.data[j].deviceId);
                if(historyVideoState == 2){
                  this.selectedHistoricalVideoAddressList.push({videoId:res.data[j].deviceId,cameraId:res.data[j].cameraId});
                }
              }

              for (var i = 0; i < res.data.length; i++) {
                deviceIds.push(res.data[i].deviceId);
              }
              //获取视频设备信息
              this.getVideoDeviceInfo(deviceIds);
            }
          }
        })
      }else{
        //获取告警设备联动的视频设备
        deviceIds = [];
        alarmRecordId =  this.latest_alarm_information.alarmRecordId;
        console.log("告警历史ID：",alarmRecordId);
        getAlarmLinkageVideoList(alarmRecordId).then(alarm =>{
          if (alarm.code === 0) {
            for (var j = 0; j < alarm.data.length; j++){
              if (alarm.data[j].devicePointId == null){
                deviceIds.push(alarm.data[j].deviceId);
              }
            }
            //获取视频设备信息
            this.getVideoDeviceInfo(deviceIds);
          }
        });


        getAlarmLinkageHistorVideoList(alarmRecordId).then(res =>{
          if (res.code === 0) {
            if (res.data.length > 0) {
              this.alarmLinkageVideoList = res.data;
              console.log("历史告警联动视频：",this.alarmLinkageVideoList);
            }
          }
        })
      }

      //获取告警设备信息
      this.getDeviceInformation(deviceIds);
    },

    //获取视频设备信息
    getVideoDeviceInfo(deviceIds){
      getDeviceInfoById(deviceIds).then(res =>{
        console.log("设备id",res);
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.linkageVideo = res.data;
            console.log("联动视频：", this.linkageVideo);

            if(this.videoType === "history"){
              for (var i = 0; i < res.data.length; i++) {
                if(!this.checkSwitch(res.data[i].id)){
                  this.checkSwitchList.push(res.data[i].id);
                }
              }
            }
          }
        }
      })
    },

    //获取告警设备信息
    getDeviceInformation(){
      let deviceIds = [this.latest_alarm_information.deviceId];
      getDeviceInfoById(deviceIds).then(res =>{
        if (res.code === 0) {
          this.device_information = res.data[0];
          console.log("告警设备信息：", this.device_information);
        }
      })
    },

    // 鼠标移入
    mouseOver(id) {
      this.mouseMonitoring = true;
      this.videoId = id;
      this.initialization = false;
      console.log("鼠标进入",this.videoId);
    },

    // 鼠标移出视频
    mouseLeave() {
      this.mouseMonitoring = false;
      this.videoId = '';
      console.log("鼠标出去");
    },

    //查看历史视频
    historicalVideo(cameraId,videoId){
      // this.cameraId = cameraId;
      this.videoId = videoId;
      this.videoSwitch = false;
      this.initialization = false;

      let historyVideoState = this.historyVideo(cameraId,videoId);
      if(historyVideoState == 0 || historyVideoState == 1){
        this.updateCameraId(cameraId,videoId);
      }else if(historyVideoState == 2){
        this.selectedHistoricalVideoAddressList.push({videoId:videoId,cameraId:cameraId});
      }

      if(!this.checkSwitch(videoId)){
        this.checkSwitchList.push(videoId);
      }
      console.log("历史视频播放：",this.checkSwitchList,this.selectedHistoricalVideoAddressList)
    },

    //查看历史画面
    historicalPicture(type,row){
      if(type === "history"){
        //剪切新的告警联动视频
        let alarmRecordId;
        if (this.videoType === "history"){
          alarmRecordId =  this.latest_alarm_information.id;
        }else{
          alarmRecordId =  this.latest_alarm_information.alarmRecordId;
        }
        disConnectByRecordIdAndDeviceId(alarmRecordId,row).then(res =>{
          if (res.code === 0){
            console.log("查看历史画面");
            this.$message({
              message: '请稍后点击 时间段 ' + res.data.startTime + ' 至 '+ res.data.stopTime +' 的标签，查看历史画面',
              type: 'warning'
            });
          }
        });
        console.log("剪切新的告警联动视频：",alarmRecordId);
      }else{
        console.log("查看实时画面");
        this.initialization = true;
        this.videoSwitch = true;
        //移除选中的历史视频
        this.checkSwitchRemove(row);
        //移除播放的历史视频
        this.historyVideoRemove(row);
      }
    },

    //根据视频设备查询播放的历史视频
    queryVideoByVideoId(videoId){
      console.log("根据视频设备查询播放的历史视频:    ",this.selectedHistoricalVideoAddressList,videoId  );
      if(this.videoType === "history" && this.selectedHistoricalVideoAddressList.length == 0){
        for (var j = 0; j < this.alarmLinkageVideoList.length; j++) {
          if (this.alarmLinkageVideoList[j].videoId == videoId){
            return this.alarmLinkageVideoList[j].cameraId;
          }
        }
      }else{
        for(var i = 0; i < this.selectedHistoricalVideoAddressList.length; i++){
          if (this.selectedHistoricalVideoAddressList[i].videoId == videoId){
            return this.selectedHistoricalVideoAddressList[i].cameraId;
          }
        }
      }
    },

    //判断视频设备是否存在并判断选中的历史视频是否存在 （0：视频设备存在历史视频不存在；1：视频设备存在历史视频存在；2视频设备不存在历史视频不存在）
    historyVideo(cameraId,videoId){
      let videoState = false;
      let cameraState = false;
      for(var i = 0; i < this.selectedHistoricalVideoAddressList.length; i++){
        if (this.selectedHistoricalVideoAddressList[i].videoId == videoId){
          videoState = true;
        }
        if (this.selectedHistoricalVideoAddressList[i].cameraId == cameraId){
          cameraState = true;
        }
      }

      if (videoState && cameraState){
        return 1;
      }else if (videoState && !cameraState){
        return 0;
      }else if (!videoState && !cameraState){
        return 2;
      }
    },

    //修改播放的历史视频
    updateCameraId(cameraId,videoId){
      for(var i = 0; i < this.selectedHistoricalVideoAddressList.length; i++){
        if (this.selectedHistoricalVideoAddressList[i].videoId == videoId){
          this.selectedHistoricalVideoAddressList[i].cameraId = cameraId;
        }
      }
    },

    //移除播放的历史视频
    historyVideoRemove(row){
      for(var i = 0; i < this.selectedHistoricalVideoAddressList.length; i++){
        if (this.selectedHistoricalVideoAddressList[i].videoId == row){
          this.checkSwitchList.splice(i,1);
        }
      }
    },

    //判断是否这个历史视频已经被点击
    checkSwitch(row){
      for(var i = 0; i < this.checkSwitchList.length; i++){
        if (this.checkSwitchList[i] == row){
          return true;
        }
      }
      return false;
    },

    //移除保存点击过的历史视频
    checkSwitchRemove(row){
      for(var i = 0; i < this.checkSwitchList.length; i++){
        if (this.checkSwitchList[i] == row){
          this.checkSwitchList.splice(i,1);
        }
      }
    },

    //告警处理
    alarmHandling() {
      this.deviceDialogVisible = true;
      this.code = "1";
      this.title = "告警处理";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.alarmId = this.latest_alarm_information.id;
    },

    //消警
    alarmElimination() {
      this.deviceDialogVisible = true;
      this.code = "2";
      this.title = "消警";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.alarmId = this.latest_alarm_information.id;
    },

    //告警日志
    viewLog() {
      this.code = "3";
      this.title = "告警日志";
      this.diaWidth = "60%";
      this.diaHeight = "60vh";
      let isDesc = false;
      let historyAlarmId = this.latest_alarm_information.alarmRecordId;
      if (this.videoType === "history"){
        historyAlarmId = this.latest_alarm_information.id;
        isDesc = true;
      }

      listByRecordId(historyAlarmId,isDesc).then(res=>{
        this.activities=packageList(res.data,this.latest_alarm_information.ticketNo);
        this.deviceDialogVisible = true;
      });
    },

    //刷新页面
    refreshAlarmInformation(data){
      if (data == 'isConfirm'){//刷新
        getAlarmRealTimeById(this.latest_alarm_information.id).then(res =>{
          if (res.code === 0 && res.data != null){
            this.latest_alarm_information = res.data;
            //告警联动视频
            this.getAlarmLinkageVideo();
          }
        });
        console.log("实时告警页面刷新参数：",this.latest_alarm_information);


      }else{
        this.dialog(false);
        console.log("实时告警页面关闭");
      }
    },

    //关闭页面
    dialog(data){
      // (data) => this.alarmInformationVisible = data
      console.log("关闭： ",data);
      this.selectedHistoricalVideoAddressList = [];
      this.checkSwitchList = [];
      this.alarmInformationVisible = data;
      this.$emit('alarmInformationVisible', data);
    },
    //视频样式
    videoStyle(row){
      row = row+1;
      if (row == 0 || row%3 == 1){
        return `padding-left: 2%;`;
      }else if (row/3 == 1){
        return `padding-left: 1%; padding-right: 2%;`;
      }else{
        return `padding-left: 1%;`;
      }
    }

  },
}
</script>

<style scoped>

</style>
